import { Injectable } from '@angular/core';
import { CmxHttpClient } from '@cemex/cmx-client-layout';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { switchMap, filter, map, catchError } from 'rxjs/operators';
import {
  LOAD_FULL_SALES_AREA,
  LoadJobsiteFullSalesArea,
  LoadJobsiteFullSalesAreaComplete,
  LOAD_SALES_AREA_SUCCESS,
  LoadJobsiteSalesAreaComplete,
  LoadJobsiteFullSalesAreaFail,
} from '../../../actions/jobsite-actions/jobsite.actions';
import { Observable, of } from 'rxjs';
import { FullSalesArea } from '@cemex-core/cmx-api';
import { ExperiencesService } from '@ordersnproducts/modules/shared/services/experiences.service';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

@Injectable()
export class JobsiteLoadFullSalesAreaEffects {
  constructor(
    private actions$: Actions,
    private http: CmxHttpClient,
    private rmsExperience: ExperiencesService,
  ) {}

  listenJobsiteSalesArea$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_SALES_AREA_SUCCESS),
      filter((action: LoadJobsiteSalesAreaComplete) => !!action.payload),
      switchMap((payload) => {
        const rmsWay = this.rmsExperience.isRmsEnabled();
        if (rmsWay) {
          return of(new LoadJobsiteFullSalesArea(payload.payload[0].salesArea.links));
        } else if (!rmsWay) {
          return of(new LoadJobsiteFullSalesAreaFail(null));
        } else {
          return of(null);
        }
      }),
    ),
  );

  loadFullSalesArea$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_FULL_SALES_AREA),
      filter((action: LoadJobsiteFullSalesArea) => !!action.payload),
      switchMap((action: LoadJobsiteFullSalesArea) => {
        return this.http.get<FullSalesArea>(action.payload.self).pipe(
          map((response) => {
            const salesOrg = _safe(() => response.salesOrganizationCode);
            return !!salesOrg ? new LoadJobsiteFullSalesAreaComplete(response) : new LoadJobsiteFullSalesAreaFail(null);
          }),
          catchError((error) => of(new LoadJobsiteFullSalesAreaFail(error))),
        );
      }),
    ),
  );
}
